import type { ComponentType } from 'react'
import * as icons from 'lucide-react'
import type { LucideProps } from 'lucide-react'

function toPascalCase(kebab: string): string {
  return kebab
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

export interface IconProps extends Omit<LucideProps, 'size'> {
  name: string
  size?: number
}

// Lucide, 1.5px stroke, rounded caps. `name` is kebab-case (e.g. "layout-dashboard"),
// matching the kit's data-lucide convention. Vendored from the Admin Console unchanged.
export function Icon({ name, size = 18, strokeWidth = 1.5, ...rest }: IconProps) {
  const Component = (icons as unknown as Record<string, ComponentType<LucideProps>>)[toPascalCase(name)]
  if (!Component) return null
  return <Component size={size} strokeWidth={strokeWidth} {...rest} />
}
